export default __webpack_public_path__ + "67a1d283ead07a5ba3eeb79f0e2e11aa.jpg";